import { EtatValidationDevis, OperationResponse } from 'api/quote';
import { quotesAPI } from 'services/swagger-api';

/**
 * Quote validation endpoints (api/backoffice/devis/{devisId}/validation[/demande]).
 * They go through the generated client: the success toaster comes from
 * `OperationResponse.notification`, a business failure comes back with `isSuccess: false`.
 */
export const getQuoteValidation = (devisId: string): Promise<EtatValidationDevis> =>
  quotesAPI.getQuoteValidation({ devisId });

export const requestQuoteValidation = (
  devisId: string,
  message?: string | null
): Promise<OperationResponse> =>
  quotesAPI.requestQuoteValidation({
    devisId,
    demanderValidationCommand: { message: message?.trim() || null }
  });

export const cancelQuoteValidationRequest = (devisId: string): Promise<OperationResponse> =>
  quotesAPI.cancelQuoteValidationRequest({ devisId });
